import { t } from 'i18next'

import { FormGroup, Label } from '~/components/unform'
import { Container as ContainerInput } from '~/components/unform/Input/styles'

export type DestinationUrlValue = {
  url: string
  brand?: string
  publisher_id?: string
}

interface Props {
  value?: DestinationUrlValue[] | null
  onChange?: (value: DestinationUrlValue[]) => void
  destinationsConfig?: DestinationUrlsConfig[]
  isMultiDestination?: boolean
  isRequired?: boolean
}

/**
 * Controlled destination-URL fields shared between the "Destino do anúncio"
 * panel (while a sub-publisher reviews a network campaign) and the approve
 * modal, so both edit the exact same value. Handles single URL and
 * multi-brand (one input per brand from `destinationsConfig`).
 */
const DestinationUrlsFields = ({
  value,
  onChange,
  destinationsConfig,
  isMultiDestination,
  isRequired
}: Props) => {
  const matches = (item: DestinationUrlValue, config: DestinationUrlsConfig) =>
    item.brand === config.code &&
    (item.publisher_id === config.publisher_id || !item.publisher_id)

  const getUrlFor = (config: DestinationUrlsConfig) =>
    value?.find(item => matches(item, config))?.url || ''

  const handleSingleChange = (url: string) => {
    onChange?.([{ url }])
  }

  const handleMultiChange = (config: DestinationUrlsConfig, url: string) => {
    const others = (value || []).filter(item => !matches(item, config))

    if (!url) {
      onChange?.(others)
      return
    }

    onChange?.([
      ...others,
      { url, brand: config.code, publisher_id: config.publisher_id }
    ])
  }

  if (!isMultiDestination) {
    return (
      <FormGroup>
        <ContainerInput>
          <input
            value={value?.[0]?.url || ''}
            onChange={e => handleSingleChange(e.target.value)}
            placeholder={t('rm:adDestination.description')}
            required={isRequired}
          />
        </ContainerInput>
      </FormGroup>
    )
  }

  return (
    <div className="d-flex flex-column gap-3">
      {destinationsConfig?.map(config => (
        <FormGroup
          key={`${config.publisher_id}-${config.code}`}
          className="d-flex flex-column gap-2"
        >
          <Label text={config.name} isRequired={isRequired} />
          <ContainerInput>
            <input
              value={getUrlFor(config)}
              onChange={e => handleMultiChange(config, e.target.value)}
              required={isRequired}
            />
          </ContainerInput>
        </FormGroup>
      ))}
    </div>
  )
}

export default DestinationUrlsFields
